import { BLOCK_TYPES } from '../constants.richEditor';
import type {
  TableCellElement,
  TableElement,
  TableRowElement
} from '../custom-types';

export function createTable(columns: number, rows: number): TableElement {
  const rowNodes = [...new Array(rows)].map(() => createRow(columns));
  return {
    type: BLOCK_TYPES.TABLE,
    children: rowNodes
  };
}

export function createRow(columns: number): TableRowElement {
  const cellNodes: TableCellElement[] = [...new Array(columns)].map(() =>
    createCell()
  );
  return {
    type: BLOCK_TYPES.TABLE_ROW,
    children: cellNodes
  };
}

export function createCell(): TableCellElement {
  return {
    type: BLOCK_TYPES.TABLE_CELL,
    children: [{ text: '' }]
  };
}
